import { useState, useEffect, useContext } from "react";
import { Census_func } from "../../../api/devices/census/census_func";
import { SideMenu } from "../../../components/side_menu/inline_side_menu.component";
import { DataTable } from "../../../components/data_table/data_table.component";
import OverLay from "../../../components/side_menu/overlay_side_menu.component";
import { OverflowSetCustomExample } from "../../../components/side_menu/overFlowSet.component";
import { Stack, StackItem } from "@fluentui/react";
import { CSVLink } from 'react-csv';
import { MenuItem, Button, MenuList, MenuButton, Divider, Text, Badge, Body1Strong, Title3, Body1, Caption1, FluentProvider, webLightTheme, Theme, createLightTheme, createDarkTheme, BrandVariants, Input, Card } from "@fluentui/react-components";
import { Info20Regular, GroupList20Regular, DesktopPulse20Regular, Wrench20Regular, ShieldQuestion20Regular, LockClosedKey20Regular, BookDatabase20Regular, BookTemplate20Regular, ChatMultipleHeart20Regular, Filter20Filled, FilterDismiss20Filled, Desktop20Filled, ArrowClockwise20Regular, ArrowDownload20Regular, Settings20Regular, ArrowMaximize16Regular, Dismiss16Regular, DismissSquare24Filled, ArrowMaximize20Regular, DesktopCheckmark20Regular, WrenchScrewdriver20Regular, AlertBadge20Regular, Info20Filled } from "@fluentui/react-icons";
import { Breadcrumbs } from "../../../components/breadcrumbs/breadcrumbs.component";
import { Pagination } from "../../../components/pagination/pagination.component";
import { useNavigate } from "react-router-dom";
import { MenuDropdown } from "../../../components/dropdown/menu.component";
import { DropdownComponent } from "../../../components/dropdown/dropdown.component";
import { FullScreen, useFullScreenHandle } from "react-full-screen"
import { fullscreenIcon, lightTheme, primaryIcon, exitIcon, messageTheme, overflowDivider, SubSectionResponsive, DynamicBoxingCSS, parentHome, wraperStyle, secondaryIcon, dashboardTheme } from "../../../styles/customStyles";
import DialogBox from "../../../components/dialog/dialog.component";
import { GlobalContext } from "../../../hooks/globalContext";
import FullScreenButton from "../../../components/fullscreen/fullScreen.component";
import { SkeletonDataTable } from "../../../components/skeleton/skeletonDataTable";
import { SearchBar } from "../../../components/searchbar/searchbar.component";

const handleExportCSV = () => {
  // Programmatically trigger the CSV export link
  const csvExportLink = document.getElementById('csv-export-link');
  if (csvExportLink) {
    csvExportLink.click();
  }
};

export const ComplianceStatus = () => {
  const navigate = useNavigate();
  const contextValue: any = useContext(GlobalContext);
  const tenantName = contextValue.tenantName;
  const [final_data, set_final_data] = useState(null);
  const [tableData2, setTableData2] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [leftOpen, setLeftOpen] = useState(false);
  const [leftOpenSubMenu, setleftOpenSubMenu] = useState(true);
  const [overlayOpen, setOverlayOpen] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPageNo, setCurrentPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [exportData, setExportData] = useState([]);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [isfilter, setIsFilter] = useState(false);
  const [isResetDisabled, setResetDisabled] = useState(true);
  const [filterArray, setFilterArray] = useState<string[]>([]);
  const [dropDownValue1, setDropDownValue1] = useState<any>();
  const [dropDownValue2, setDropDownValue2] = useState<any>();
  const [permissions, setPermissions] = useState(['all']);
  const [loading, setLoading] = useState(true);
  const [isRefresh, setIsRefresh]: any = useState(false);

  const handleFilterArray = (): any => {
    const value1 = dropDownValue1
    const value2 = dropDownValue2;
    if (value1 !== undefined && value1 !== "" && value2 !== undefined && value2 !== "") {
      const result = value1 + " : " + value2;
      setFilterArray([...filterArray, result]);
      setIsFilter(true);
    }
  }
  const handleFilterValueSelect = (event: { target: { value: Event; }; }): void => {
    alert(event.target.value);
  }
  const handleCloseFilter = (index: any): any => {
    console.log("clicked");
    const updatedArray = filterArray.filter((x, itemIndex) => itemIndex !== index);
    setFilterArray(updatedArray);
  }

  useEffect(() => {
    if (filterArray.length > 0)
      setResetDisabled(false)

  }, [filterArray])

  const handle = useFullScreenHandle();

  const inputChange = (e: any) => {
    const enteredValue = e.target.value;
    console.log("entered value", enteredValue)
    let name = e.target.name;
    if (name === 'filter') {
      setDropDownValue2(enteredValue);
    }
  }

  var menuItems: any = [];

  //   if(permissions.includes("all") || permissions.includes("overview_Read") || permissions.includes("overview_ReadandExport") || permissions.includes("overview_Fullaccess")) 
  //   {
  //     menuItems.push
  //     (
  //       <MenuItem key={0} onClick={() => navigate("/manage/devices/overview")}
  //       icon={
  //         <Stack horizontal tokens={{childrenGap:40}}>
  //           <StackItem><Text></Text></StackItem>
  //           <StackItem> <Info20Regular {...primaryIcon}/> </StackItem>
  //         </Stack>}>
  //         <Stack tokens={{childrenGap:30}} horizontal>
  //           <StackItem><Text></Text></StackItem>
  //           <StackItem> <Caption1> Overview </Caption1> </StackItem>
  //           <StackItem> <Stack tokens={{childrenGap:80}} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
  //           {/* SPACING IN INLINE SIDEBAR */}
  //         </Stack>
  //       </MenuItem>
  //     ) 
  //   }

  //  if(permissions.includes("all") || permissions.includes("deviceClassification_Read") || permissions.includes("deviceClassification_ReadandExport") || permissions.includes("deviceClassification_Fullaccess")) 
  //  {
  //   menuItems.push
  //   (
  //     <MenuItem key={1} onClick={() => navigate("/manage/devices/device_classification")}
  //     icon={
  //       <Stack horizontal tokens={{childrenGap:40}}>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <GroupList20Regular {...primaryIcon}/> </StackItem>
  //       </Stack>}>
  //       <Stack tokens={{childrenGap:30}} horizontal>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <Caption1> Device Classification </Caption1> </StackItem>
  //       </Stack>
  //     </MenuItem>
  //   );
  //  }

  //  if(permissions.includes("all") || permissions.includes("monitor_Read") || permissions.includes("monitor_ReadandExport") || permissions.includes("monitor_Fullaccess")) 
  //   {
  //     menuItems.push
  //      (
  //        <MenuItem key={2} onClick={() => navigate("/manage/devices/monitor")}
  //        icon={
  //          <Stack horizontal tokens={{childrenGap:40}}>
  //            <StackItem><Text></Text></StackItem>
  //            <StackItem> <DesktopPulse20Regular {...primaryIcon}/> </StackItem>
  //          </Stack>}>
  //          <Stack tokens={{childrenGap:30}} horizontal>
  //            <StackItem><Text></Text></StackItem>
  //            <StackItem> <Caption1> Monitors </Caption1> </StackItem>
  //            <StackItem> <Stack tokens={{childrenGap:80}} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>

  //          </Stack>
  //        </MenuItem>
  //      );
  //   }

  //  if(permissions.includes("all") || permissions.includes("remediation_Read") || permissions.includes("remediation_ReadandExport") || permissions.includes("remediation_Fullaccess")) 
  //  {
  //    menuItems.push
  //    (
  //      <MenuItem key={3} onClick={() => navigate("/manage/devices/remediation")}
  //      icon={
  //        <Stack horizontal tokens={{childrenGap:40}}>
  //          <StackItem><Text></Text></StackItem>
  //          <StackItem> <Wrench20Regular {...primaryIcon}/> </StackItem>
  //        </Stack>}>
  //        <Stack tokens={{childrenGap:30}} horizontal>
  //          <StackItem><Text></Text></StackItem>
  //          <StackItem> <Caption1> Remediations </Caption1> </StackItem>
  //        </Stack>
  //      </MenuItem>
  //    );
  //  }

  //  if(permissions.includes("all") || permissions.includes("compPolicies_Read") || permissions.includes("compPolicies_Fullaccess") || permissions.includes("compPolicies_ReadandExport"))
  //   {
  //     menuItems.push
  //      (
  //        <MenuItem key={4} onClick={() => navigate("/manage/devices/compliancepolicies")}
  //        icon={
  //          <Stack horizontal tokens={{childrenGap:40}}>
  //            <StackItem><Text></Text></StackItem>
  //            <StackItem> <ShieldQuestion20Regular {...primaryIcon}/> </StackItem>
  //          </Stack>}>
  //          <Stack tokens={{childrenGap:30}} horizontal>
  //            <StackItem><Text></Text></StackItem>
  //            <StackItem> <Caption1> Compliance Policies </Caption1> </StackItem>
  //          </Stack>
  //        </MenuItem>
  //      );
  //   } 

  //  if(permissions.includes("all") || permissions.includes("conditionalAccess_Read") || permissions.includes("conditionalAccess_ReadandExport") || permissions.includes("conditionalAccess_Fullaccess"))
  //   {
  //     menuItems.push
  //     (
  //       <MenuItem key={5} onClick={() => navigate("/manage/devices/conditionalaccess")}
  //       icon={
  //         <Stack horizontal tokens={{childrenGap:40}}>
  //           <StackItem><Text></Text></StackItem>
  //           <StackItem> <LockClosedKey20Regular {...primaryIcon}/> </StackItem>
  //         </Stack>}>
  //         <Stack tokens={{childrenGap:30}} horizontal>
  //           <StackItem><Text></Text></StackItem>
  //           <StackItem> <Caption1> Conditional Access </Caption1> </StackItem>
  //         </Stack>
  //       </MenuItem>  
  //     );
  //   } 

  // if(permissions.includes("all") || permissions.includes("userSurveys_Read") || permissions.includes("userSurveys_ReadandExport") || permissions.includes("userSurveys_Fullaccess")) 
  // {
  //   menuItems.push
  //   (
  //     <MenuItem key={6} onClick={() => navigate("/manage/devices/usersurvey")}
  //     icon={
  //       <Stack horizontal tokens={{childrenGap:40}}>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <ChatMultipleHeart20Regular {...primaryIcon}/> </StackItem>
  //       </Stack>}>
  //       <Stack tokens={{childrenGap:30}} horizontal>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <Caption1> User Survey </Caption1> </StackItem>
  //       </Stack>
  //     </MenuItem>
  //   );
  // }


  // if(permissions.includes("all") || permissions.includes("dataCollection_Read") || permissions.includes("dataCollection_ReadandExport") || permissions.includes("dataCollection_Fullaccess"))
  //   {
  //     menuItems.push
  //       (
  //         <MenuItem key={7} onClick={() => navigate("/manage/devices/datacollection")}
  //         icon={
  //           <Stack horizontal tokens={{childrenGap:40}}>
  //             <StackItem><Text></Text></StackItem>
  //             <StackItem> <BookDatabase20Regular {...primaryIcon}/> </StackItem>
  //           </Stack>}>
  //           <Stack tokens={{childrenGap:30}} horizontal>
  //             <StackItem><Text></Text></StackItem>
  //             <StackItem> <Caption1> Data&nbsp;Collection </Caption1> </StackItem>
  //             <StackItem> <Stack tokens={{childrenGap:50}} horizontal> <StackItem><Text></Text></StackItem> <StackItem><Text></Text></StackItem> </Stack> </StackItem>
  //           </Stack>
  //         </MenuItem>
  //       );
  //   }

  // if(permissions.includes("all") || permissions.includes("activityLog_Read") || permissions.includes("activityLog_ReadandExport") || permissions.includes("activityLog_Fullaccess")) 
  // {
  //   menuItems.push
  //   (
  //     <MenuItem key={8} onClick={() => navigate("/manage/devices/activitylog")}
  //     icon={
  //       <Stack horizontal tokens={{childrenGap:40}}>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <BookTemplate20Regular {...primaryIcon}/> </StackItem>
  //       </Stack>}>
  //       <Stack tokens={{childrenGap:30}} horizontal>
  //         <StackItem><Text></Text></StackItem>
  //         <StackItem> <Caption1> Activity Log </Caption1> </StackItem>
  //       </Stack>
  //     </MenuItem>
  //   );
  // }

  if (permissions.includes("all") || permissions.includes("activityLog_Read") || permissions.includes("activityLog_ReadandExport") || permissions.includes("activityLog_Fullaccess")) {
    menuItems.push
      (
        <FluentProvider theme={lightTheme}>
          <MenuItem key={8} onClick={() => navigate("/manage/devices/compliance_status")}
            icon={
              <Stack horizontal tokens={{ childrenGap: 40 }}>
                <StackItem><Text></Text></StackItem>
                <StackItem> <BookTemplate20Regular {...primaryIcon} /> </StackItem>
              </Stack>}>
            <Stack tokens={{ childrenGap: 30 }} horizontal>
              <StackItem><Text></Text></StackItem>
              <StackItem> <Caption1> Compliance&nbsp;Status&nbsp; </Caption1> </StackItem>
            </Stack>
          </MenuItem>
        </FluentProvider>
      );
  }
  //inline side menu content code ends here

  //data table column name code starts here
  var columns = [
    // { key: "machine_name", label: <Body1Strong> Device Names </Body1Strong>  },
    { key: "parameter", label: <Body1Strong> Parameter </Body1Strong> },
    { key: "status", label: <Body1Strong> Status </Body1Strong> },
    { key: "date", label: <Body1Strong> Date </Body1Strong> },
  ];
  //data table column name code ends here

  //data table for filter
  var columns1 = [
    { key: "parameter", label: <Caption1> Parameter </Caption1> },
    { key: "status", label: <Caption1> Status </Caption1> },
    { key: "date", label: <Caption1> date </Caption1> },
  ];

  // overflow set contents code starts here
  var overFlowComponent = {
    data:
      <>
        <StackItem>
          <Button shape="circular" disabled={loading} appearance="subtle" size="small" onClick={() => { setCurrentPageNo(1); setIsRefresh(true); setLoading(true); }}>
            <Stack tokens={{ childrenGap: 5 }} horizontal>
              <StackItem>{loading ? <ArrowClockwise20Regular {...secondaryIcon} /> : <ArrowClockwise20Regular {...primaryIcon} />}</StackItem>
              <StackItem> <Caption1> Refresh </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem>

        <StackItem>
          <CSVLink id="csv-export-link" data={exportData} filename={`${tenantName}_compliance_Policies_assignmentlist.csv`}>
            <Button shape="circular" disabled={loading || tableData.length === 0} appearance="subtle" size="small" onClick={() => setCurrentPageNo(1)}>
              <Stack tokens={{ childrenGap: 5 }} horizontal>
                <StackItem>{loading || tableData.length === 0 ? <ArrowDownload20Regular {...secondaryIcon} /> : <ArrowDownload20Regular {...primaryIcon} />} </StackItem>
                <StackItem> <Caption1> Export </Caption1> </StackItem>
              </Stack>
            </Button>
          </CSVLink>
        </StackItem>

        {/* <StackItem>
          <Button shape="circular" appearance="subtle" size="small">
            <Stack tokens={{childrenGap:5}} horizontal>
              <StackItem> <Settings20Regular {...primaryIcon}/> </StackItem>
              <StackItem> <Caption1> Manage View </Caption1> </StackItem>
            </Stack>
          </Button>
        </StackItem> */}
      </>
    ,
  };
  // overflow set contents code ends here

  useEffect(() => {
    if (contextValue.logedInFrom !== undefined && contextValue.logedInFrom?.platform === "ServiceNow") {
      var deviceName = contextValue.logedInFrom?.device;
    } else {
      var deviceName = contextValue.automationDetails.automationName;
    }

    const fetchData = async () => {
      const apiUrl = 'https://pinot-dev.nanoheal.work/sql';

      // If searchVal exists, modify the SQL query to include search filter
      var whereCondition = '';
      if (searchVal.length > 0) {
        whereCondition = ` AND parameters LIKE '%${searchVal}%' `;
      }

      // var dartNo = 288;
      let sqlQuery = `select parameters, machine, status, servertime from t1_d312_policy where machine = '${deviceName}' ${whereCondition}`;
      // sqlQuery += ' limit 1000';

      const requestBody = {
        sql: sqlQuery,
        trace: false,
        queryOptions: '',
      };
      let responseData: any = '';
      try {
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(requestBody),
        });

        if (!response.ok) {
          throw new Error(`No result`);
        }
        console.log('response - ' + response)
        responseData = await response.json();

      } catch (err) {
        console.log('error ', err)
      } finally {
        setLoading(false)
      }

      console.log("responseData=", responseData);

      const rowData = responseData != undefined && responseData?.resultTable != undefined ? responseData?.resultTable?.rows : [];

      const uniqueData: any = [];
      if (rowData.length > 0) {

        rowData.map((row: any) => {
          const isDuplicate = uniqueData.some((existingRow: any) =>
            JSON.stringify(existingRow) === JSON.stringify(row)
          );
          if (!isDuplicate) {
            uniqueData.push(row);
          }
        });

        var cnt = 0;
        uniqueData !== undefined && uniqueData !== null ? uniqueData.map((data: any, i: any) => {
          if (i >= (50 * (currentPageNo - 1) && cnt < 50)) {
            cnt++;

            tempExportData.push({
              machine_name: data[1],
              parameter: data[1],
              status: data[2],
              date: new Date(data[0] * 1000).toLocaleString(),
            });

            tempTableData.push({
              checkbox: 'hide',
              machine_name: { label: <Caption1> {data[1]} </Caption1> },
              parameter: { label: <Caption1> {data[0]} </Caption1> },
              status: { label: <Caption1> {data[2]} </Caption1> },
              date: { label: <Caption1> {data[3]} </Caption1> },
            });
          }
        }) : (tempTableData = []);
        setExportData(tempExportData);

        tempTableData.length > 0 ? setTableData(tempTableData) : setTableData([]);
        setTimeout(() => {
          setLoading(false);
        }, 500);
        setTotalRecords(uniqueData?.length);
        setTotalPages(Math.ceil((uniqueData?.length) / 50));
      } else {
        setTableData([]);
        setTotalRecords(0);
        setTotalPages(0);
      }
    };

    fetchData();
  }, [searchVal, currentPageNo, isRefresh]);

  var tempTableData: any = [];
  var menuLists: any = [];
  var tempExportData: any = [];

  //   useEffect(() => {
  //     // data table values append code starts here
  //     console.log("final_data=",final_data);

  //     final_data !== undefined && final_data !== null
  //       ? final_data.core_Census.map((val: any, i: any) => {
  //           menuLists.push();
  //  console.log("val.alerName=",val.alerName);

  //           tempExportData.push({
  //             notification_name: val.alerName,
  //             num_of_devices: val.nod,
  //           });



  //           tempTableData.push({
  //             checkbox:'hide',
  //             notification_name:{ label: <Button shape="circular" appearance="transparent" size="small" onClick={() => setOverlayOpen(true)}> {val.alerName} </Button> },
  //             num_of_devices: { label: <Caption1> {val.nod} </Caption1> },
  //           });
  //         }) : (tempTableData = []);
  //     setExportData(tempExportData);
  //     tempTableData.length > 0 ? setTableData(tempTableData) : (tempTableData = []);
  //   }, [final_data]);
  // data table values append code ends here

  useEffect(() => {
    console.log("tableData=", tableData);

  }, [tableData]);

  // data table values append code ends here
  var overLayData: any = {
    headerTitle: "Memory usage greater than 90%",
    size: "large",
    isTabs: true,
    tabItems: {
      Introduction: (
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <StackItem>
              <Body1Strong>What does this Alert Do?</Body1Strong>
            </StackItem>
            <StackItem>
              <Caption1>
                This alert indicates that data in Office mobile apps may be
                shared or leaked to unmanaged apps on iOS and Android devices.
                In this scenario, data protection settings should be applied to
                your organization’s managed mobile apps to prevent such
                occurrences.
              </Caption1>
            </StackItem>
            <StackItem>
              <Body1Strong>
                What is the Benefit of Addressing this Alert?
              </Body1Strong>
            </StackItem>
            <StackItem>
              <Caption1>
                Addressing this alert helps prevent data in Office mobile apps
                from being shared or leaked to unmanaged apps on iOS and
                Android devices, ensuring better data security for your
                organization.
              </Caption1>
            </StackItem>
          </Stack>
        </>
      ),

      Devices: (
        <>
          <Stack tokens={{ childrenGap: 15, padding: 10 }}>
            <Stack verticalAlign="center" tokens={{ childrenGap: 10 }}>
              <StackItem>
                <OverflowSetCustomExample
                  overlayOpen={overlayOpen}
                  setOverlayOpen={setOverlayOpen}
                  component={overFlowComponent}
                />
                <Divider />
              </StackItem>
              <StackItem>
                <StackItem>
                  <Stack horizontal tokens={{ childrenGap: 20 }}>
                    <SearchBar columnSearch={"for Parameter"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />

                    <StackItem>
                      <MenuDropdown
                        open={filterMenuOpen}
                        btn={
                          <MenuButton
                            shape="circular"
                            size="small"
                            onClick={() => setFilterMenuOpen(true)}
                          >
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                              <Body1> Filter </Body1>
                            </Stack>
                          </MenuButton>
                        }
                        itemVal={
                          <>
                            <Body1Strong> Add a Filter </Body1Strong>
                            <Divider />
                            <MenuList>
                              <Stack tokens={{ childrenGap: 5 }}>
                                <StackItem>
                                  {" "}
                                  <Text></Text>{" "}
                                </StackItem>
                                <StackItem>
                                  {" "}
                                  <Caption1> Filter </Caption1>{" "}
                                </StackItem>
                                {/* <DropdownComponent optionData={columns} /> */}
                                <DropdownComponent
                                  optionData={columns1}
                                  setDropDownValue={setDropDownValue1}
                                  dropDownvalue={dropDownValue1}
                                />
                                <StackItem>
                                  {" "}
                                  <Divider />{" "}
                                </StackItem>
                                <StackItem>
                                  {" "}
                                  <Caption1> Value </Caption1>{" "}
                                </StackItem>
                                {/* <DropdownComponent optionData={columns} /> */}
                                <Input
                                  size="small"
                                  onChange={inputChange}
                                  name="filter"
                                  value={dropDownValue2}
                                />
                                <StackItem>
                                  {" "}
                                  <Divider />{" "}
                                </StackItem>
                                <Stack tokens={{ childrenGap: 10 }} horizontal>
                                  <StackItem>
                                    {" "}
                                    <Button shape="circular"
                                      appearance="primary"
                                      onClick={() => {
                                        handleFilterArray();
                                        setFilterMenuOpen(false);
                                      }}
                                    >
                                      {" "}
                                      <Caption1> Apply </Caption1>{" "}
                                    </Button>{" "}
                                  </StackItem>
                                  <StackItem>
                                    {" "}
                                    <Button shape="circular"
                                      onClick={() => setFilterMenuOpen(false)}
                                    >
                                      {" "}
                                      <Caption1> Cancel </Caption1>{" "}
                                    </Button>{" "}
                                  </StackItem>
                                </Stack>
                              </Stack>
                            </MenuList>
                          </>
                        }
                      />
                    </StackItem>
                    <StackItem>
                      {filterArray.length > 0 &&
                        filterArray.map((item, index) => (
                          <Button shape="circular" size="small">
                            <Stack tokens={{ childrenGap: 5 }} horizontal>
                              <StackItem> {item} </StackItem>
                              <StackItem>
                                <Stack tokens={{ childrenGap: 1 }}>
                                  <StackItem>
                                    <Text></Text>
                                  </StackItem>
                                  <StackItem>
                                    <Dismiss16Regular
                                      onClick={() => {
                                        handleCloseFilter(index);
                                      }}
                                    />
                                  </StackItem>
                                </Stack>
                              </StackItem>
                            </Stack>
                          </Button>
                        ))}
                    </StackItem>
                    <StackItem
                      onClick={() => {
                        setFilterArray([]);
                        setIsFilter(false);
                        setDropDownValue2("");
                        setResetDisabled(true);
                      }}
                    >
                      <Button shape="circular"
                        appearance="subtle"
                        size="small"
                        disabled={isResetDisabled}
                      >
                        <Stack tokens={{ childrenGap: 5 }} horizontal>
                          <StackItem>
                            {" "}
                            <FilterDismiss20Filled />{" "}
                          </StackItem>
                          <StackItem>
                            {" "}
                            <Caption1> Reset Filters </Caption1>{" "}
                          </StackItem>
                        </Stack>
                      </Button>
                    </StackItem>
                  </Stack>
                  <Stack tokens={{ childrenGap: 5, padding: 5 }}>
                    <StackItem>
                      <Text></Text>
                    </StackItem>
                    <FluentProvider theme={messageTheme}>
                      <Card appearance="subtle" size="small">
                        <Stack tokens={{ childrenGap: 10 }} horizontal>
                          <StackItem>
                            {" "}
                            <Info20Filled {...primaryIcon} />{" "}
                          </StackItem>
                          <StackItem>
                            {" "}
                            <Caption1>
                              Executing the following troubleshooters will
                              assist you in devices management and provide a
                              resolutions for any errors. Be mindful when
                              executing the troubleshooter on multiple devices.{" "}
                            </Caption1>{" "}
                          </StackItem>
                        </Stack>
                      </Card>
                    </FluentProvider>
                  </Stack>
                </StackItem>
                <Stack tokens={{ childrenGap: 10 }}>
                  <StackItem>
                    <Text></Text>
                  </StackItem>
                  <StackItem>
                    <Text></Text>
                  </StackItem>
                </Stack>
                {tableData.length > 0 && (
                  <Stack
                    horizontal
                    enableScopedSelectors
                    horizontalAlign="space-between"
                  >
                    <StackItem>
                      <Caption1>
                        {" "}
                        Showing {(currentPageNo - 1) * 50 + 1} to{" "}
                        {currentPageNo * 50 > totalRecords
                          ? totalRecords
                          : currentPageNo * 50}{" "}
                        of {totalRecords} Records{" "}
                      </Caption1>
                    </StackItem>
                    <StackItem>
                      <Pagination
                        totalPages={totalPages}
                        currentPageNo={currentPageNo}
                        setCurrentPageNo={setCurrentPageNo}
                      />
                    </StackItem>
                  </Stack>
                )}
              </StackItem>
              {/* <StackItem>Data table comes here.</StackItem> */}
              {loading ? (
                <SkeletonDataTable />
              ) : tableData.length > 0 ? (
                <DataTable tableData={tableData} columns={columns} />
              ) : (
                <Stack
                  horizontalAlign="center"
                  tokens={{ childrenGap: 15, padding: 10 }}
                >
                  <StackItem>
                    <Text size={500}>No result.</Text>
                  </StackItem>
                </Stack>
              )}
            </Stack>
          </Stack>
        </>
      ),
    },
    footerData: (
      <>
        <Button shape="circular"
          appearance="primary"
          size="medium"
          onClick={() => {
            setOverlayOpen(false);
            setTimeout(() => {
              navigate("/manage/troubleshoot/troubleshoot");
            }, 1000);
          }}
        >
          {" "}
          Troubleshoot Fix{" "}
        </Button>
      </>
    ),
  };

  return (
    <>
      <FullScreen handle={handle} className="fullScreenBackgroundColor">
        <StackItem grow shrink>
          <Stack tokens={{ childrenGap: 10 }} horizontal>
            {contextValue?.logedInFrom?.platform !== "ServiceNow" && <StackItem grow shrink>
              <Stack horizontalAlign="start">
                <StackItem grow shrink> <Breadcrumbs pageName="Devices" subPageName="Compliance Status" subPageLink="/manage/devices/overview" /> </StackItem>
              </Stack>
            </StackItem>}
            <StackItem grow shrink>
              <Stack horizontalAlign="end">
                <StackItem grow shrink>
                  <FullScreenButton handle={handle} />
                </StackItem>
              </Stack>
            </StackItem>
          </Stack>
        </StackItem>
        <FluentProvider style={SubSectionResponsive} theme={dashboardTheme}>
          <Stack tokens={{ childrenGap: 20 }} style={DynamicBoxingCSS} horizontal>
            <StackItem style={DynamicBoxingCSS}>
              {/* pages code starts here */}
              <Stack style={DynamicBoxingCSS}>
                <Stack tokens={{ childrenGap: 25 }} horizontal>
                  <StackItem> <Text></Text> </StackItem>
                  <StackItem>
                    <Title3> Devices | Compliance Status </Title3>
                  </StackItem>
                </Stack>
                <Stack style={parentHome} horizontal >
                  {/* SPACING BETWEEN INLINE AND PAGE */}
                  <SideMenu leftOpenSubMenu={leftOpenSubMenu} setleftOpenSubMenu={setleftOpenSubMenu} menuItems={menuItems} />
                  <StackItem style={DynamicBoxingCSS}>
                    <Stack style={parentHome} tokens={{ childrenGap: 10 }}>
                      <StackItem>
                        <OverflowSetCustomExample overlayOpen={overlayOpen} setOverlayOpen={setOverlayOpen} component={overFlowComponent} />
                        <Divider />
                      </StackItem>
                      <StackItem>
                        <StackItem style={wraperStyle}>
                          <Stack horizontalAlign="space-between" wrap horizontal tokens={{ childrenGap: 10 }}>
                            <Stack horizontal tokens={{ childrenGap: 10 }}>
                              <StackItem>
                              <SearchBar columnSearch={"for Parameter"} searchVal={searchVal} setSearchVal={setSearchVal} setLoading={setLoading} disabled={loading || tableData.length === 0} />
                              </StackItem>
                              <StackItem>
                                <MenuDropdown open={filterMenuOpen} btn=
                                  {
                                    <MenuButton disabled={loading || tableData.length === 0} shape="circular" size="small" onClick={() => setFilterMenuOpen(true)}>
                                      <Stack tokens={{ childrenGap: 5 }} horizontal>
                                        {loading || tableData.length === 0 ? <Filter20Filled {...secondaryIcon} /> : <Filter20Filled {...primaryIcon} />}
                                        <Body1> Filter </Body1>
                                      </Stack>
                                    </MenuButton>
                                  } itemVal={
                                    <>
                                      <Body1Strong> Add a Filter </Body1Strong>
                                      <Divider />
                                      <MenuList>
                                        <Stack tokens={{ childrenGap: 5 }}>
                                          <StackItem> <Text></Text> </StackItem>
                                          <StackItem> <Caption1> Filter </Caption1> </StackItem>
                                          <DropdownComponent optionData={columns1} setDropDownValue={setDropDownValue1} dropDownvalue={dropDownValue1} />
                                          <StackItem> <Divider /> </StackItem>
                                          <StackItem> <Caption1> Value </Caption1> </StackItem>
                                          <Input size='small' onChange={inputChange} name="filter" value={dropDownValue2} />
                                          <StackItem> <Divider /> </StackItem>
                                          <Stack tokens={{ childrenGap: 10 }} horizontal>
                                            <StackItem> <Button shape="circular" appearance="primary" onClick={() => { handleFilterArray(); setFilterMenuOpen(false) }}> <Caption1> Apply </Caption1> </Button> </StackItem>
                                            <StackItem> <Button shape="circular" onClick={() => setFilterMenuOpen(false)}> <Caption1> Cancel </Caption1> </Button> </StackItem>
                                          </Stack>
                                        </Stack>
                                      </MenuList>
                                    </>
                                  }
                                />
                              </StackItem>
                              <StackItem onClick={() => { setFilterArray([]); setIsFilter(false); setDropDownValue2(''); setResetDisabled(true); }}>
                                <Button shape="circular" appearance="subtle" size="small" disabled={isResetDisabled}>
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> <FilterDismiss20Filled /> </StackItem>
                                    <StackItem> <Caption1> Reset Filters </Caption1> </StackItem>
                                  </Stack>
                                </Button>
                              </StackItem>
                            </Stack>
                            {(tableData.length > 0 && !loading) && <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>}
                          </Stack>
                          {filterArray.length > 0 && <Stack tokens={{ padding: '10px 0px 0px 0px' }}>
                            <Stack wrap horizontal >
                              {filterArray.length > 0 && filterArray.map((item, index) => (
                                <Button shape="circular" size="small">
                                  <Stack tokens={{ childrenGap: 5 }} horizontal>
                                    <StackItem> {item.includes("00:00") ? item.split("00:00")[0].trim() : item} </StackItem>
                                    <StackItem>
                                      <Stack tokens={{ childrenGap: 1 }}>
                                        <StackItem><Text></Text></StackItem>
                                        <StackItem><Dismiss16Regular onClick={() => { handleCloseFilter(index) }} /></StackItem>
                                      </Stack>
                                    </StackItem>
                                  </Stack>
                                </Button>
                              ))}
                            </Stack>
                          </Stack>}
                        </StackItem>
                        <Stack tokens={{ childrenGap: 10 }}><StackItem><Text></Text></StackItem><StackItem><Text></Text></StackItem></Stack>
                        {tableData.length > 0 && <Stack horizontal enableScopedSelectors horizontalAlign="space-between" >
                          <StackItem> {totalRecords > 0 && <Caption1>  Showing {((currentPageNo - 1) * 50) + 1} to {(currentPageNo * 50) > totalRecords ? totalRecords : (currentPageNo * 50)} of {totalRecords} Records </Caption1>} </StackItem>
                          <StackItem> <Pagination setLoading={setLoading} totalPages={totalPages} currentPageNo={currentPageNo} setCurrentPageNo={setCurrentPageNo} /> </StackItem>
                        </Stack>}
                      </StackItem>
                      {/* <Census_func data={final_data} func={set_final_data} searchVal={searchVal} pageNo = {(currentPageNo - 1) * 10} setTotalPages = {setTotalPages} setTotalRecords = {setTotalRecords} /> */}
                      {loading ? (<SkeletonDataTable />) : tableData.length > 0 ? (<DataTable tableData={tableData} columns={columns} />) : <Stack horizontalAlign="center" tokens={{ childrenGap: 15, padding: 10 }}><StackItem><Text size={500}>No result.</Text></StackItem></Stack>}
                    </Stack>

                  </StackItem>
                </Stack>
              </Stack>
              <OverLay overlayopen={overlayOpen} setOverlayOpen={setOverlayOpen} overlayData={overLayData} />
            </StackItem>
            <StackItem><Text></Text></StackItem>
          </Stack>
        </FluentProvider>
      </FullScreen>
    </>
  );
};
